<div class="additional-products-selection">
  <div class="current-product">
    <div class="product">
      <h4 class="product-name">
        {{ productConfig.name }}
      </h4>
    </div>

    <span class="product-price">
      <price-display [price]="priceCalculationService.singleProductTotal"
                     [quantity]="productConfig.quantity">
      </price-display>
    </span>
  </div>
  <hr />

  <div class="additional-products-title">
      {{ 'i18n.additionalProducts.title' | translate }}
  </div>

  <div class="additional-products">
    <div [ngClass]="productConfig.additionalProducts.length == 1 ?
                    'one-column' : 'two-columns'">
      <div class="main-additional-product additional-product"
           *ngIf="productConfig.additionalProducts[0]; let product">
        <div class="product-image">
          <ng-container *ngIf="getFeatureGroupsCount(product) !== 1">
            <img *ngIf="product.image" src="{{product.image.mediumURL}}" />
          </ng-container>
          <ng-container *ngIf="getFeatureGroupsCount(product) === 1">
            <img *ngIf="getSelectedFeature(product) &&
                        getSelectedFeatureMediaUrl(product)"
                 src="{{ getSelectedFeatureMediaUrl(product) }}" />
          </ng-container>
        </div>
        <div class="product-title">
          {{ product.name }}
        </div>
        <price-display [price]="priceCalculationService
                                  .getProductPriceWithFeatures(product)"
                       [quantity]="product.quantity">
        </price-display>
        <ul class="details">
          <li *ngFor="let detail of product.bulletedDescription"
              [innerHTML]="detail">
          </li>
        </ul>
        <div class="feature-selection"
             *ngIf="getFeatureGroupsCount(product) > 0">
          <div class="feature-group"
               *ngFor="let group of objToArray(product.featureGroups);
                       trackBy: trackById">
            <span class="group-name">
              {{ group.name }}:
            </span>

            <single-option-chooser [displayStyle]="'DropDown'"
                                   [options]="getFeaturesAsOptions(group)"
                                   [selectedValue]="group.selectedFeature"
                                   (selectedValueChange)="selectedValueChanged(
                                       product.id, group.id, $event)">

            </single-option-chooser>

          </div>
        </div>

        <div class="add-to-cart-container">
          <mat-checkbox [checked]="additionalProductIsSelected(product.id)"
                        [labelPosition]="'before'"
                        (change)="setAdditionalProductIsSelected(
                                      product.id, $event.source.checked)">
            <a mat-raised-button size="small" color="primary">
              {{ 'i18n.additionalProducts.addToCart' | translate }}
            </a>
          </mat-checkbox>
        </div>
      </div>

      <div class="other-additional-products"
           *ngIf="productConfig.additionalProducts.length > 1">
        <ng-container *ngFor="let product of productConfig.additionalProducts;
                     let i = index; trackBy: trackById">
          <div class="other-additional-product additional-product"
               *ngIf="i > 0">
            <div class="product-info">
              <div class="product-image">
                <ng-container *ngIf="getFeatureGroupsCount(product) !== 1">
                  <img *ngIf="product.image" src="{{product.image.mediumURL}}" />
                </ng-container>
                <ng-container *ngIf="getFeatureGroupsCount(product) === 1">
                  <img *ngIf="getSelectedFeature(product) &&
                              getSelectedFeatureMediaUrl(product)"
                       src="{{ getSelectedFeatureMediaUrl(product) }}" />
                </ng-container>
              </div>
              <div class="product-details">
                <div class="product-title">
                  {{ product.name }}
                </div>
                <price-display [price]="priceCalculationService
                                          .getProductPriceWithFeatures(product)"
                               [quantity]="product.quantity">
                </price-display>
                <input class="acc-checkbox" type="checkbox" id="acc-{{i}}" />
                <label for="acc-{{i}}" class="acc-label">
                  {{ 'i18n.additionalProducts.showMore' | translate }}
                </label>
                <ul class="details">
                  <li *ngFor="let detail of product.bulletedDescription"
                      [innerHTML]="detail">
                  </li>
                </ul>
                <div class="feature-selection"
                     *ngIf="getFeatureGroupsCount(product) > 0">
                  <div class="feature-group"
                       *ngFor="let group of objToArray(product.featureGroups);
                               trackBy: trackById">
                    <span class="group-name">
                      {{ group.name }}:
                    </span>

                    <single-option-chooser [displayStyle]="'DropDown'"
                                           [options]="getFeaturesAsOptions(group)"
                                           [selectedValue]="group.selectedFeature"
                                           (selectedValueChange)="selectedValueChanged(
                                               product.id, group.id, $event)">

                    </single-option-chooser>

                  </div>
                </div>
              </div>
            </div>

            <div class="add-to-cart-container">
              <mat-checkbox [checked]="additionalProductIsSelected(product.id)"
                            [labelPosition]="'before'"
                            (change)="setAdditionalProductIsSelected(
                                          product.id, $event.source.checked)">
                <a mat-raised-button size="small" color="primary">
                  {{ 'i18n.additionalProducts.addToCart' | translate }}
                </a>
              </mat-checkbox>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
<progress-buttons></progress-buttons>



// WEBPACK FOOTER //
// ./src/app/additional-products-selection/additional-products-selection.component.html